// assets/member-mode.js
window.MemberMode = (function(){
    var pendingVariantSwitchPromise = Promise.resolve();

    function set(flag){
      try { 
        localStorage.setItem('member_mode', flag ? 'true' : 'false'); 
      } catch(e){}
      
      var wasChanged = document.body.classList.contains('member-mode') !== !!flag;
      document.body.classList.toggle('member-mode', !!flag);
      
      // Force browser reflow/repaint if class actually changed
      if (wasChanged) {
        void document.body.offsetHeight;
      }
      
      // Trigger custom event for pricing updates
      try {
        document.dispatchEvent(new CustomEvent('memberModeChanged', { detail: { active: !!flag } }));
      } catch(e) {}
    }
  
    function get(){
      try {
        return localStorage.getItem('member_mode') === 'true';
      } catch(e) {
        return false;
      }
    }
    
    function setFreeTeeMode(flag){
      try { 
        localStorage.setItem('freetee_mode', flag ? 'true' : 'false'); 
      } catch(e){}
      document.body.classList.toggle('freetee-mode', !!flag);
    }
  
    function getFreeTeeMode(){
      try {
        return localStorage.getItem('freetee_mode') === 'true';
      } catch(e) {
        return false;
      }
    }
  
    function fromCart(cart, skipAutoSwitch){
      // Check if we're on a collection page with explicit mode setting
      var inMemberCollection = false;
      try {
        inMemberCollection = sessionStorage.getItem('member_collection_active') === 'true';
      } catch(e) {}
      
      // Check for "Free Tee Offer" tag in cart items - this triggers freetee mode
      var hasFreeTeeOffer = cart.items?.some(function(i){
        var tags = i.product_tags || '';
        
        // Handle both array and string formats
        if (Array.isArray(tags)) {
          return tags.some(function(tag) {
            return tag.toLowerCase().trim() === 'free tee offer';
          });
        }
        
        // Handle string format (comma-separated or single tag)
        return tags.toLowerCase().includes('free tee offer');
      }) || false;
      
      // If Free Tee Offer product is in cart, disable member mode and enable freetee mode
      if (hasFreeTeeOffer) {
        set(false);
        setFreeTeeMode(true);
        return false;
      } else {
        // Clear freetee mode if no Free Tee Offer products in cart
        if (getFreeTeeMode()) {
          setFreeTeeMode(false);
        }
      }
      
      // Rule 1: Check if customer is VIP tagged - if so, always member mode
      // VIP customers should always have member mode active regardless of cart contents
      var isVipCustomer = false;
      if (typeof window.customerTags !== 'undefined' && window.customerTags) {
        if (Array.isArray(window.customerTags)) {
          isVipCustomer = window.customerTags.some(function(tag) {
            var tagStr = String(tag).trim().toLowerCase();
            return tagStr === 'vip' || tagStr === 'member';
          });
        }
      }
      
      // Rule 2: if any line item is a Member variant (not Non-Member) OR any product_type === Membership => member mode on.
      var hasMemberVariant = cart.items?.some(function(i){
        // Check variant title more precisely - must contain "Member" but NOT "Non-Member"
        var title = i.variant_title || '';
        var productTitle = i.title || '';
        var fullTitle = title + ' ' + productTitle;
        
        // Check if it's specifically a Member variant (not Non-Member)
        if (fullTitle.includes('Non-Member')) {
          return false; // This is a Non-Member variant
        }
        
        return fullTitle.includes('Member'); // This is a Member variant
      }) || false;
  
      var hasMembershipProduct = cart.items?.some(function(i){
        return i.product_type === 'Membership' || (i.product_tags || '').includes('membership');
      }) || false;
  
      var hasOfferTag = cart.items?.some(function(i){
        var tags = i.product_tags || '';
        
        // Handle both array and string formats
        if (Array.isArray(tags)) {
          var hasOffer = tags.some(function(tag) {
            return tag.toLowerCase().trim() === 'offer';
          });
          return hasOffer;
        }
        
        // Handle string format (comma-separated or single tag)
        return tags.toLowerCase().includes('offer');
      }) || false;
  
      // Cart-based member mode triggers
      var shouldBeMemberMode = isVipCustomer || hasMemberVariant || hasMembershipProduct || hasOfferTag;
      
      // Collection-based override: if we're in a member collection, force member mode ON
      if (inMemberCollection) {
        shouldBeMemberMode = true;
        console.log('Member mode maintained by collection');
      }
      
      var wasMemberMode = get();
      
      set(shouldBeMemberMode);
      
      // NEW FEATURE: When member mode becomes active, switch all items to Member variants
      // Only do this if member mode just became active (not if it was already active)
      if (shouldBeMemberMode && !wasMemberMode && !skipAutoSwitch) {
        switchAllToMemberVariants(cart);
      }
      
      return shouldBeMemberMode;
    }
    
    // NEW FUNCTION: Switch all cart items with Membership option to Member variants
    function switchAllToMemberVariants(cart) {
      if (!cart || !cart.items || cart.items.length === 0) return Promise.resolve(cart);
      
      console.log('Member mode activated - switching all items to Member variants...');
      
      // Build an array of updates to make
      var updates = [];
      
      cart.items.forEach(function(item) {
        var title = item.variant_title || '';
        var productTitle = item.title || '';
        var fullTitle = title + ' ' + productTitle;
        
        // Check if this item has a "Non-Member" variant (meaning it has membership options)
        if (fullTitle.includes('Non-Member')) {
          // This item needs to be switched to Member variant
          // We need to find the corresponding Member variant
          
          // Extract other options (like size, color) from the variant title
          // Variant title format is typically "Option1 / Option2 / Option3"
          var options = (item.variant_title || '').split('/').map(function(o) {
            return o.trim();
          }).filter(function(o) {
            return o !== 'Non-Member';
          });
          
          // Get product handle - try from item.handle first, then extract from URL
          var handle = item.handle;
          if (!handle && item.url) {
            // URL format is typically /products/handle?variant=123
            var match = item.url.match(/\/products\/([^?\/]+)/);
            if (match) handle = match[1];
          }
          
          // Store the update info
          updates.push({
            lineKey: item.key,
            productHandle: handle,
            currentVariantId: item.variant_id,
            quantity: item.quantity,
            otherOptions: options,
            title: item.title
          });
        }
      });
      
      if (updates.length === 0) {
        console.log('No items need switching');
        return Promise.resolve(cart);
      }
      
      console.log('Items to switch:', updates);
      
      // Fetch product data to find Member variant IDs
      var promises = updates.map(function(update) {
        if (!update.productHandle) {
          console.error('No product handle found for item:', update.title);
          return Promise.resolve(null);
        }
        
        return fetch('/products/' + update.productHandle + '.js')
          .then(function(r) { 
            if (!r.ok) throw new Error('Product fetch failed');
            return r.json(); 
          })
          .then(function(product) {
            // Find the Member variant that matches the other options
            var memberVariant = product.variants.find(function(v) {
              // Check if this is a Member variant
              var isMember = v.option1 === 'Member' || v.option2 === 'Member' || v.option3 === 'Member';
              if (!isMember) return false;
              
              // Check if it has the same other options
              var variantOptions = [v.option1, v.option2, v.option3].filter(function(o) {
                return o && o !== 'Member';
              });
              
              // Match all other options
              return update.otherOptions.every(function(opt) {
                return variantOptions.includes(opt);
              });
            });
            
            if (memberVariant && memberVariant.available) {
              return {
                lineKey: update.lineKey,
                newVariantId: memberVariant.id,
                quantity: update.quantity
              };
            }
            console.log('No available Member variant found for:', update.title);
            return null;
          })
          .catch(function(e) {
            console.error('Failed to fetch product ' + update.productHandle + ':', e);
            return null;
          });
      });
      
      pendingVariantSwitchPromise = Promise.all(promises).then(function(results) {
        var validUpdates = results.filter(function(r) { return r !== null; });
        
        if (validUpdates.length === 0) {
          console.log('No valid Member variants found');
          return;
        }
        
        // OPTIMIZED: Batch all removals, then batch all additions for faster updates
        var updates = {};
        validUpdates.forEach(function(update) {
          updates[update.lineKey] = 0; // Set quantities to 0 to remove
        });
        
        // Step 1: Remove all Non-Member items in one request
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          // Step 2: Add all Member variants in parallel
          var addPromises = validUpdates.map(function(update) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: update.newVariantId,
                quantity: update.quantity
              })
            });
          });
          return Promise.all(addPromises);
        });
      }).then(function() {
        console.log('Successfully switched items to Member variants');
        
        // Refresh cart display immediately (no delay needed)
        refreshFromServer();
        
        // Trigger cart update events
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        
        // Update cart drawer if available
        var cartDrawerItems = document.querySelector('cart-drawer-items');
        if (cartDrawerItems && typeof cartDrawerItems.updateCart === 'function') {
          cartDrawerItems.updateCart();
        }
      }).catch(function(e) {
        console.error('Failed to switch variants:', e);
      });

      return pendingVariantSwitchPromise;
    }
  
    function refreshFromServer(){
      // Add cache-busting parameter to ensure fresh data
      var cacheBuster = '?t=' + new Date().getTime();
      return fetch('/cart.js' + cacheBuster, { 
        credentials: 'same-origin',
        cache: 'no-store'
      })
        .then(function(r){ 
          if (!r.ok) throw new Error('Cart fetch failed');
          return r.json(); 
        })
        .then(function(cart){ 
          // If cart.js doesn't have product_tags, fetch custom template for tags
          if (cart.items && cart.items.length > 0 && !cart.items[0].product_tags) {
            return fetch('/cart?view=member-check.json', { credentials: 'same-origin' })
              .then(function(r){ return r.json(); })
              .then(function(customCart){
                // Merge product_tags from custom template
                cart.items = cart.items.map(function(item, index) {
                  if (customCart.items && customCart.items[index]) {
                    item.product_tags = customCart.items[index].product_tags;
                    if (!item.product_type && customCart.items[index].product_type) {
                      item.product_type = customCart.items[index].product_type;
                    }
                    if (!item.variant_title && customCart.items[index].variant_title) {
                      item.variant_title = customCart.items[index].variant_title;
                    }
                  }
                  return item;
                });
                fromCart(cart); 
                return cart;
              })
              .catch(function(e) {
                console.warn('MemberMode: Custom template failed, using cart.js data only');
                fromCart(cart); 
                return cart;
              });
          } else {
            fromCart(cart); 
            return cart; 
          }
        })
        .catch(function(e){
          console.error('MemberMode: Failed to fetch cart', e);
          return Promise.reject(e);
        });
    }

    function ensureCartRefreshed(){
      return refreshFromServer().then(function(cart) {
        return pendingVariantSwitchPromise.catch(function() {
          return null;
        }).then(function() {
          return refreshFromServer();
        });
      });
    }
  
    // Check if current collection should force member mode
    function checkCollectionMode() {
      // Define collections that should always show member pricing
      var memberCollections = [
        '7-tee-sale'
      ]; // Add or remove collection handles as needed
      
      var currentPath = window.location.pathname;
      var isInMemberCollection = false;
      
      // Check if we're on a collection page
      if (currentPath.includes('/collections/')) {
        var match = currentPath.match(/\/collections\/([^/?]+)/);
        if (match) {
          var currentCollection = match[1];
          
          // Check if this is a member collection
          if (memberCollections.includes(currentCollection)) {
            isInMemberCollection = true;
            console.log('Member collection detected:', currentCollection);
            
            // Store that we're in a member collection
            try {
              sessionStorage.setItem('member_collection_active', 'true');
              sessionStorage.setItem('member_collection_name', currentCollection);
            } catch(e) {}
            
            // Activate member mode
            set(true);
            
            // Force pricing display update with multiple attempts for reliability
            if (typeof window.updatePricingDisplay === 'function') {
              // Immediate call
              window.updatePricingDisplay();
              // Delayed call to catch any late-loading elements
              setTimeout(function() {
                window.updatePricingDisplay();
                console.log('Pricing updated for member collection (delayed)');
              }, 100);
              // One more for good measure
              setTimeout(function() {
                window.updatePricingDisplay();
              }, 300);
            }
            
            return true;
          } else {
            // We're in a regular collection (not a member collection)
            // Don't force member mode OFF - let cart-based rules determine member mode
            // Just clear the member collection flag
            try {
              sessionStorage.removeItem('member_collection_active');
              sessionStorage.removeItem('member_collection_name');
            } catch(e) {}
            
            // Don't change member mode state - let it be determined by cart contents
            return false;
          }
        }
      }
      
      // Check if we're on a product page and came from a member collection
      if (currentPath.includes('/products/')) {
        try {
          var fromMemberCollection = sessionStorage.getItem('member_collection_active') === 'true';
          if (fromMemberCollection) {
            console.log('Product page from member collection - maintaining member mode');
            set(true);
            return true;
          }
        } catch(e) {}
      }
      
      // If we're not on a collection or product page, clear all collection flags
      if (!currentPath.includes('/collections/') && !currentPath.includes('/products/')) {
        try {
          sessionStorage.removeItem('member_collection_active');
          sessionStorage.removeItem('member_collection_name');
        } catch(e) {}
      }
      
      return isInMemberCollection;
    }
  
    // Initialize on load
    function init(){
      // PRIORITY: Check if customer is VIP - if so, always activate member mode
      var isVipCustomer = false;
      if (typeof window.customerTags !== 'undefined' && window.customerTags) {
        if (Array.isArray(window.customerTags)) {
          isVipCustomer = window.customerTags.some(function(tag) {
            var tagStr = String(tag).trim().toLowerCase();
            return tagStr === 'vip' || tagStr === 'member';
          });
        }
      }
      
      if (isVipCustomer) {
        set(true);
        console.log('MemberMode: VIP customer detected, member mode activated');
      }
      
      // First, check if we should force member mode based on collection
      var collectionForced = checkCollectionMode();
      
      // Sync with any server-side class that might already be present
      var hasServerClass = document.body.classList.contains('member-mode');
      var hasLocalStorage = get();
      
      // If server says member but localStorage doesn't, trust server
      if (hasServerClass && !hasLocalStorage) {
        set(true);
      }
      // If localStorage says member but server doesn't, check cart (unless collection already forced it or VIP)
      else if (hasLocalStorage && !hasServerClass && !collectionForced && !isVipCustomer) {
        refreshFromServer();
      }
    }
  
    return { set, get, setFreeTeeMode, getFreeTeeMode, fromCart, refreshFromServer, ensureCartRefreshed, init, switchAllToMemberVariants, checkCollectionMode };
  })();
